import React, { useState, useEffect } from 'react';
import { Text } from '@shopify/polaris';

export default function StudentRow(props) {
  return <tr>
    <td className={`student-name student-name-${props.index}`} colSpan="8">
      <Text as="span" fontWeight="semibold">{props.name}</Text><br/>
      <Text as="span" color="subdued">{props.email}</Text>
    </td>
  </tr>
}
